import { createSlice } from '@reduxjs/toolkit'
import { IGrant } from '../../types/Grants'
import {fetchGrantAsync, fetchGrantAsyncBuilder} from "./asyncRequests";

export interface GrantInitialState {
  data: IGrant
  loading: boolean
  error: string
}

const initialState: GrantInitialState = {
  data: {} as IGrant,
  loading: false,
  error: '',
}

const GrantSlice = createSlice({
  name: 'grantSlice',
  initialState,
  reducers: {
    resetGrant: (state) => {
      state.data = initialState.data
    },
    resetError: (state) => {
      state.error = initialState.error
    },
  },
  extraReducers: (builder) => {
      fetchGrantAsyncBuilder(builder)
  },
})

export const GrantActions = {
  ...GrantSlice.actions,
    fetchGrantAsync
}

export const GrantReducer = GrantSlice.reducer
